import AsyncAlpine from "async-alpine";
import Alpine from "alpinejs";

// Initialize Alpine
window.Alpine = Alpine;
AsyncAlpine.init(Alpine);
Alpine.start();
